// V3 SHARED MODULES
import V3BookingWidget from './v3-booking-widget';
import V3FlightStopOverComponent from './v3-flight-stop-over-component';

type ModulesType = {
  [key: string]: () => any;
};

const v3SharedModules: ModulesType = {
  v3BookingWidget: () => V3BookingWidget,
  v3FlightStopoverModule: () => V3FlightStopOverComponent,
};

export default v3SharedModules;
